module.exports = __webpack_public_path__ + "assets/img/kv-988b13f6.jpg";